import { Box, Card, CardContent, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { dashboardCardSx } from "../layout/dashboardStyles";

interface TicketMinuteLineCardProps {
  ticketsMinutes: number[];
}

export const TicketMinuteLineCard: React.FC<TicketMinuteLineCardProps> = ({
  ticketsMinutes,
}) => {
  const today = new Date();
  const currentDay = today.getDate();
  const validDays = ticketsMinutes.slice(0, currentDay);
  const avg =
    validDays.length > 0
      ? Math.round(validDays.reduce((sum, n) => sum + n, 0) / validDays.length)
      : 0;
  const labels = ticketsMinutes.map((_, i) => (i + 1).toString());
  const data = ticketsMinutes;

  return (
    <Card
      sx={{
        ...dashboardCardSx,
        width: "100%",
        minWidth: 0,
      }}
    >
      <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          Tiempo promedio de venta
        </Typography>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          {avg} min
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          gutterBottom
        >
          Promedio de ventas cerradas (Enviadas a preparación)
        </Typography>
        <Box sx={{ mt: 1.5, width: "100%", height: { xs: 76, sm: 90 } }}>
          <LineChart
            height={80}
            xAxis={[
              {
                data: labels,
                scaleType: "band",
              },
            ]}
            series={[
              {
                data,
                label: "Ticket en minutos",
                color: "#8A00CC",
                area: true,
                curve: "monotoneX",
                showMark: false,
              },
            ]}
            yAxis={[{}]}
            grid={{ horizontal: false, vertical: false }}
            margin={{ top: 6, bottom: 24, left: 0, right: 0 }}
            sx={{
              ".MuiChartsAxis-root": { display: "none" },
              ".MuiChartsLegend-root": { display: "none" },
              ".MuiAreaElement-root": { opacity: 1, fill: "#561375ff" },
              ".MuiLineElement-root": { strokeWidth: 2.5 },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
